import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import React, { useMemo, useRef } from 'react';
import { isDark } from '../common/utils';
import { DataGridCell } from './data-grid-cell';
import styles from './data-grid.module.scss';
const DataGridRow = ({ data, columnConfigs, style, layoutStyle, border, fixedHeight, zebra, size, }) => {
    const isDarkMode = useMemo(() => isDark(), []);
    const cellsData = useRef(Object.keys(data)
        .filter(k => k !== 'id')
        .map(key => ({
        id: nanoid(),
        name: key,
        value: data[key],
    })));
    const rowClass = useMemo(() => {
        return classNames(styles.row, {
            [styles[`row_${layoutStyle}`]]: true,
            [styles.border]: border,
            rc_row_fixed_height: fixedHeight,
            // [styles.row_zebra]: zebra,
            [styles[`row_${size}`]]: true,
            [styles.dark]: isDarkMode,
        });
    }, [layoutStyle, zebra]);
    return (_jsx("div", { className: rowClass, style: style, role: "row", children: columnConfigs?.map(col => {
            const data = cellsData.current.find(cell => cell.name === col.name);
            if (data) {
                const { value, id, name } = data;
                const formatter = col.formatter;
                return (_jsx(DataGridCell, { value: value, name: name + '', border: border, fixedHeight: fixedHeight, formatter: formatter, zebra: zebra }, id));
            }
        }) }));
};
DataGridRow.displayName = 'DataGridRow';
export { DataGridRow };
